import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'components/atoms/modal';
import { DisconnectModalTypes } from './disconnect-modal.types';

export const DisconnectModal = ({
  onClose,
  onOkay,
  loading,
}: DisconnectModalTypes) => {
  return (
    <Modal
      onCancel={onClose}
      onOk={onOkay}
      okButtonProps={{ loading }}
      cancelButtonProps={{ disabled: loading }}
      closable={!loading}
      title={
        <FormattedMessage id="settings.integrations.slack.disconnect.title" />
      }
      okText={<FormattedMessage id="disconnect" />}
      okType="danger"
      confirmLoading={false}
      visible
    >
      <p>
        <FormattedMessage id="settings.integrations.slack.disconnect.content" />
      </p>
    </Modal>
  );
};
